import { render, staticRenderFns } from "./tabelaLimiteMortalidadeForm.vue?vue&type=template&id=d710caaa&scoped=true&"
import script from "./tabelaLimiteMortalidadeForm.vue?vue&type=script&lang=js&"
export * from "./tabelaLimiteMortalidadeForm.vue?vue&type=script&lang=js&"
import style0 from "./tabelaLimiteMortalidadeForm.vue?vue&type=style&index=0&id=d710caaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d710caaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDataTable,VFlex,VForm,VLayout,VTextField})
